export interface EnvironmentConfig {
  NODE_ENV: 'development' | 'production';
  APP_NAME: string;
  BASE_URL: string;
  API_BASE_URL: string;
  ENVIRONMENT_TYPE: 'development' | 'production';
  SHOW_DEV_INDICATORS: boolean;
}

export const getEnvironmentConfig = (): EnvironmentConfig => {
  const isViteProd = import.meta.env.PROD;
  const currentUrl = typeof window !== 'undefined' ? window.location.hostname : '';

  // Branch-aware environment detection
  // Cloudflare Pages automatically sets CF_PAGES_BRANCH during deployment
  // We expose it to Vite via VITE_CF_PAGES_BRANCH in the build command
  const cfPagesBranch = import.meta.env.VITE_CF_PAGES_BRANCH || 'unknown';
  const isMainBranch = cfPagesBranch === 'main';

  // Determine if this is the production environment
  // Production = main branch + production domain OR main branch on any domain in production build
  const isProductionEnvironment = (currentUrl === 'tabpicker.app') ||
                                  (isViteProd && isMainBranch);

  return {
    NODE_ENV: isViteProd ? 'production' : 'development',
    APP_NAME: isProductionEnvironment ? 'TabPicker' : 'TabPicker (DEV)',
    BASE_URL: isProductionEnvironment
      ? 'https://tabpicker.app'
      : 'https://tabpicker.pages.dev',
    API_BASE_URL: isProductionEnvironment
      ? 'https://tabpicker.app/api'
      : 'https://tabpicker.pages.dev/api',
    ENVIRONMENT_TYPE: isProductionEnvironment ? 'production' : 'development',
    SHOW_DEV_INDICATORS: !isProductionEnvironment,
  };
};

export const ENV = getEnvironmentConfig();